import { gql } from "@apollo/client";

export const GET_LIQUIDACION_EVALUACION = gql`
query hasLiquidacionPendienteEvaluacion($idEvaluacion: Int!) {
    hasLiquidacionPendienteEvaluacion(idEvaluacion: $idEvaluacion) {
        valorEsperado
        success
        error
    }
  }
`;